import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import fr from 'facet-rest';
import Sentry from 'Integrations/Sentry';
import { useRefreshOnboardingNavigation } from 'Hooks/useRefreshEvent';
import NavigationCard from 'Views/Onboarding/Components/Navigation/NavigationCard';
import NavigationHeader from 'Views/Onboarding/Components/Navigation/NavigationHeader';
import { useNewNavbarContext } from 'Components/UI/Navigation/NewNavbar/NewNavbarContext';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import LogoutButton from 'Views/Onboarding/Components/Navigation/LogoutButton';
import styles from './styles';

const Navbar = ({
  classes,
  clientResource,
}) => {
  const isMobile = useMobileLayout();
  const { isOpen } = useNewNavbarContext();
  const { loadOnboardingStepCollection } = useSurveyContext();

  const [navigationResource, setNavigationResource] = React.useState(null);

  async function getNavigationData() {
    try {
      const [x] = await clientResource.relationship(fr.relationships.onboardingNavigation.name).link('related').get();
      setNavigationResource(x);
    } catch (err) {
      Sentry.createSentryErrorLog(err);
    }
  }

  useRefreshOnboardingNavigation(() => {
    getNavigationData();
  }, [clientResource]);

  React.useEffect(() => {
    getNavigationData();
  }, [clientResource]);

  if (isMobile) return null;
  // TODO skeleton?
  if (!navigationResource) return null;
  return (
    <React.Fragment>
      <div className={classes.content}>
        <NavigationHeader
          navigationResource={navigationResource}
          clientResource={clientResource}
          AvatarProps={{
            className: classes.avatar,
          }}
          compact={!isOpen}
        />
        {navigationResource.attr('listItems').resources().list().map(el => (
          <div className={classes.cardContainer}>
            <NavigationCard
              className={classes.card}
              key={`nav-card-${el.id()}`}
              resource={el}
              compact={!isOpen}
              onClick={(link) => {
                getNavigationData();
                return loadOnboardingStepCollection(link);
              }}
            />
          </div>
        ))}
      </div>

      <LogoutButton compact={!isOpen} />
    </React.Fragment>
  );
};

Navbar.defaultProps = {
};

Navbar.propTypes = {
  classes: PropTypes.object.isRequired,
  clientResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(Navbar);
